import { createContext, useContext } from 'react';
import type { WindowManager } from './types';

const WindowManagerContext = createContext<WindowManager | null>(null);

export const WindowManagerProvider = WindowManagerContext.Provider;

/** Открывает/закрывает плавающие окна документов и справочников (§1, §8.7, §11.1). */
export function useWindowManager(): WindowManager {
  const ctx = useContext(WindowManagerContext);
  if (!ctx) throw new Error('useWindowManager() must be used within the app WindowManagerProvider');
  return ctx;
}
